import type { DeliveryDatesApiResponse } from '@app/pages/api/delivery-dates/types';
import { ObjectValues } from '@app/types/index';
import type { Cart } from '@app/types/monolith/cart';
import type { Dispatch } from 'react';
import type { CartCheckoutClient } from '../cartCheckoutClient';

type ErrorsSeverity = 'critical';

export const ErrorCode = {
  CART_FETCH_ERROR: 'CART_FETCH_ERROR',
  SHIPPING_PREFERENCE_UPDATE_ERROR: 'SHIPPING_PREFERENCE_UPDATE_ERROR',
  SHIPPING_DETAILS_UPDATE_ERROR: 'SHIPPING_DETAILS_UPDATE_ERROR',
} as const;

export type ErrorCodeType = ObjectValues<typeof ErrorCode>;

export interface Error {
  code: ErrorCodeType;
  severity: ErrorsSeverity;
}

export interface State {
  cart: Cart | null;
  cartLoading: boolean;
  deliveryDates: DeliveryDatesApiResponse | null;
  deliveryDatesLoading: boolean;
  errors?: Error[];
}

type ContextClient = { client: CartCheckoutClient };

type ContextDispatch = {
  dispatch: StateDispatch;
};

export type ContextValue =
  | (State &
      ContextClient &
      ContextDispatch & { hasStartedInitialLoad: boolean })
  | undefined;

export type StateDispatch = Dispatch<DispatchActions>;

// Reducer Types

export const DispatchActionsType = {
  SET_CART: 'SET_CART',
  SET_DELIVERY_DATES: 'SET_DELIVERY_DATES',
  SET_ALL_LOADING: 'SET_ALL_LOADING',
  SET_CART_LOADING: 'SET_CART_LOADING',
  SET_DELIVERY_DATES_LOADING: 'SET_DELIVERY_DATES_LOADING',
  SET_ERRORS: 'SET_ERRORS',
} as const;

export type SetCartAction = {
  type: typeof DispatchActionsType.SET_CART;
  payload: State['cart'];
};

export type SetDeliveryDatesAction = {
  type: typeof DispatchActionsType.SET_DELIVERY_DATES;
  payload: State['deliveryDates'];
};

export type SetLoadingAction = {
  type:
    | typeof DispatchActionsType.SET_ALL_LOADING
    | typeof DispatchActionsType.SET_CART_LOADING
    | typeof DispatchActionsType.SET_DELIVERY_DATES_LOADING;
  payload: boolean;
};

export type SetErrorsAction = {
  type: typeof DispatchActionsType.SET_ERRORS;
  payload: State['errors'];
};

export type DispatchActions =
  | SetLoadingAction
  | SetCartAction
  | SetDeliveryDatesAction
  | SetErrorsAction;
